export default __webpack_public_path__ + "static/media/yu.962a4c36.jpg";